var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{key:_vm.siteType.id,staticClass:"rounded-pill bg-gray-100 text-nowrap d-flex align-items-center",style:({
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: _vm.small ? 'var(--gray-300)' : _vm.siteType.kind ? _vm.siteType.kind.color : 'var(--gray-600)',
    padding: _vm.paddingString,
    fontSize: _vm.small ? '0.75em' : '1em',
  })},[(!_vm.small && _vm.siteType.kind && _vm.siteType.kind.icon.tag === 'b-icon')?_c('b-icon',_vm._b({staticClass:"rounded-circle",style:({
      backgroundColor: _vm.siteType.kind ? _vm.siteType.kind.color : 'var(--gray-600)',
      padding: '0.2em',
    }),attrs:{"variant":"light","font-scale":"1.5"}},'b-icon',_vm.siteType.kind.icon.attrs,false)):_c('span',{staticClass:"company-sites-manager__kind-dot",style:({ backgroundColor: _vm.siteType.kind ? _vm.siteType.kind.color : 'var(--gray-600)' })}),_c('span',{staticClass:"special-text text-dark",style:({ marginLeft: _vm.small ? '0.2em' : '0.4em' })},[_vm._v(_vm._s(_vm.siteType.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }